var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSupportDownloadApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 59,
    viewBox: "0 0 52 59",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.9342 58.4567C0.63093 53.8419 -9.75036 14.1626 17.6249 13.7721C21.3167 13.7337 23.7001 15.7315 26.5458 16.2756C28.6604 16.6595 30.9303 13.9306 38.1955 13.9306C42.8487 13.9306 46.9629 16.1221 49.7702 19.5819C40.5805 25.542 40.1967 37.115 51.3457 42.8447C50.2692 47.4579 43.8101 56.11 40.4253 57.8008C36.2745 59.877 31.1606 56.2252 27.0849 56.0717C23.4314 55.9548 19.7796 58.8005 15.9342 58.455V58.4567Z",
    fill: "#1D1D1B"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.7263 14.4396C33.415 14.8252 38.4902 6.32702 37.7208 0.484131C32.916 0.898023 25.264 5.66613 25.7263 14.4396Z",
    fill: "#1D1D1B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportDownloadApple);
export default __webpack_public_path__ + "static/media/support_download_apple.8730a2c689eb36fadb4165cad98c975e.svg";
export { ForwardRef as ReactComponent };